(() => {
  if (window.customHomeHeroReady) return;
  window.customHomeHeroReady = true;

  const instances = new WeakMap();

  function init(section) {
    if (!section || instances.has(section)) return;

    const slides = [...section.querySelectorAll('[data-custom-home-hero-slide]')];
    const dots = [...section.querySelectorAll('[data-custom-home-hero-dot]')];
    const autoplay = section.dataset.autoplay === 'true';
    const delay = Number(section.dataset.autoplaySeconds || 5) * 1000;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let current = 0;
    let timer;

    function show(index) {
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });

      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });

      current = index;
    }

    function stop() {
      window.clearInterval(timer);
    }

    function start() {
      stop();
      if (autoplay && !reduceMotion && slides.length > 1) {
        timer = window.setInterval(() => show((current + 1) % slides.length), delay);
      }
    }

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        show(index);
        start();
      });
    });

    section.addEventListener('mouseenter', stop);
    section.addEventListener('mouseleave', start);
    section.addEventListener('focusin', stop);
    section.addEventListener('focusout', start);

    show(0);
    start();
    instances.set(section, { show, stop });
  }

  function initWithin(scope) {
    if (scope.matches?.('[data-custom-home-hero]')) init(scope);
    scope.querySelectorAll?.('[data-custom-home-hero]').forEach(init);
  }

  initWithin(document);

  document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const section = event.target.closest('[data-custom-home-hero]');
    const slide = event.target.closest('[data-custom-home-hero-slide]');
    if (!section || !slide) return;

    const slides = [...section.querySelectorAll('[data-custom-home-hero-slide]')];
    const instance = instances.get(section);
    instance?.stop();
    instance?.show(slides.indexOf(slide));
  });
})();
